import React from "react";
import { Container, Grid, Typography } from "@material-ui/core";

import Product from "./Product/Product";
import useStyles from "./styles";

const Products = ({ categories, onAddToCart }) => {
  const classes = useStyles();

  return (
    <main className={classes.content}>
      
      {categories.map(category => {
        return (
          <Container>
            <div className={classes.toolbar} />
            <Typography  id={`#${category.name}`} className={classes.title} variant="h4" gutterBottom>
              {category.name}
            </Typography>
            <Grid container justifyContent="center" spacing={4}>
              {category.productsData.map((product) => (
                <Grid item key={product.id} xs={12} sm={6} md={4} lg={3}>
                  <Product product={product} onAddToCart={onAddToCart} />
                </Grid>
              ))}
            </Grid>
          </Container>
        );
      })}
    </main>
  );
}

export default Products;